import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import NewsCard from "./NewsCard";
import axios from "axios";
import { Menu } from "@mui/icons-material";

function News() {
  const [fetchedNews, setFetchedNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('lg')); // Mobile screen check

  const maxNews = smallScreen ? 6 : 4;

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(
          "https://newsdata.io/api/1/latest?apikey=pub_7c3fea1633424c9890e58a53e79000ed&q=business&language=en&category=business,technology"
        );
        setFetchedNews(response.data.results);
      } catch (err) {
        setError("Failed to fetch news. Please try again later.");
      } finally {
        setLoading(false);
      }
    };
    fetchNews();
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>{error}</p>;

  return (
    <Box sx={{ width: { xs: '90%', mdlg: '30%', lg: "25%" }, }}>
      <Box sx={{ textAlign: "center" }}>
        <Typography sx={{ fontSize: "1.8rem", fontWeight: "600", display: 'flex', alignItems: 'center', justifyContent: { xs: 'center', md: 'left' } }}>
            <Menu sx={{ fontSize: '2.1rem', stroke: '#242424' }} />
          NEWS
        </Typography>
      </Box>
      <Box
        sx={{
          height: "90%",
          py: 3.2,
          display: "flex",
          gap: 5.5,
          flexDirection: "column",
          alignItems: "center",
          px: { xs: 2, md: 0 }
        }}
      >
        {fetchedNews.slice(0, maxNews).map((items, index) => (
          <NewsCard key={index} {...items} />
        ))}
      </Box>
    </Box>
  );
}

export default News;
